module.exports = __webpack_public_path__ + "teqbahn-assets/media/WhatWeDoBgv3.9cdc27fa.png";